<div class="container">
    <div class="row">
        <div class="suscripcion-recibida">
            <div class="content">
                <h1 class="title">¡Gracias por confiar en vittal!</h1>
                <p class="gracias-message">Tu pago fue registrado con éxito. En breve recibirás un email con la confirmación de alta y la credencial para empezar a usar tu plan.
                </p>
        
                <p class="gracias-message"><strong>Si tenés dudas mientras tanto, podés <a href="https://api.whatsapp.com/send?phone=541130326052">escribirnos</a> por mail a <a href="mailto:cas@vittal.com.ar">cas@vittal.com.ar</a></strong></p>

                <a href="planes/promos" class="btn mt-5 ">EXPLORAR BENEFICIOS PARA SOCIOS</a>
            </div>
        </div>

    </div>
</div>